export const ITEM_PRICE_COPY = 'Item price';

export const PERSONALISATION_COPY = 'Personalisation';
export const PERSONALISATION_ADDED_COPY = 'Added';
export const PERSONALISATION_REMOVED_COPY = 'Removed';

export const TOTAL_COPY = 'Total';
